import "./Policy.css";
import { useTranslation } from "react-i18next";
import { useShippingRates } from "../../utils/shipping";
import { PRICING_OPEN } from "../../config/features";

export default function TermsPage() {
  const { t } = useTranslation();
  const shipping = useShippingRates();
  const shipVars = {
    base: shipping.base.toLocaleString(),
    jeju: shipping.jeju.toLocaleString(),
    island: shipping.island.toLocaleString(),
    jejuTotal: (shipping.base + shipping.jeju).toLocaleString(),
    islandTotal: (shipping.base + shipping.island).toLocaleString(),
  };

  return (
    <div className="policy-container">
      <h1>{t("terms_of_service")}</h1>

      <p>
        {t("policy.terms.intro")}
      </p>

      <h2>{t("policy.terms.section1.title")}</h2>

      <p>
        {t("policy.terms.section1.p1")}
      </p>

      <ul>
        <li>{t("policy.terms.section1.items.cutter")}</li>
        <li>{t("policy.terms.section1.items.upload")}</li>
        <li>{t("policy.terms.section1.items.gallery")}</li>
        <li>{t("policy.terms.section1.items.printing")}</li>
      </ul>

      <h2>{t("policy.terms.section2.title")}</h2>

      <p>
        {t("policy.terms.section2.p1")}
      </p>

      <ul>
        <li>{t("policy.terms.section2.items.email")}</li>
        <li>{t("policy.terms.section2.items.username")}</li>
      </ul>

      <p>
        {t("policy.terms.section2.p2")}
      </p>

      <h2>{t("policy.terms.section3.title")}</h2>

      <p>{t("policy.terms.section3.p1")}</p>

      <ul>
        <li>{t("policy.terms.section3.items.svg")}</li>
        <li>{t("policy.terms.section3.items.stl")}</li>
        <li>{t("policy.terms.section3.items.png")}</li>
      </ul>

      <p>
        {t("policy.terms.section3.p2")}
      </p>

      <p>
        {t("policy.terms.section3.p3")}
      </p>

      <h2>{t("policy.terms.section4.title")}</h2>

      <p>{t("policy.terms.section4.p1")}</p>

      <ul>
        <li>{t("policy.terms.section4.items.ip")}</li>
        <li>{t("policy.terms.section4.items.illegal")}</li>
        <li>{t("policy.terms.section4.items.interrupt")}</li>
        <li>{t("policy.terms.section4.items.automation")}</li>
        <li>{t("policy.terms.section4.items.security")}</li>
      </ul>

      {/* 요금제를 닫은 동안(PRICING_OPEN=false)은 구독 조항 대신 무료 이용·저장 규칙을 보여준다.
          구독 조항 문구는 지우지 않고 남겨 두었다 — 요금제를 다시 열면 그대로 돌아온다. */}
      {PRICING_OPEN ? (
        <>
          <h2>{t("policy.terms.section5.title")}</h2>

          <p>
            {t("policy.terms.section5.p1")}
          </p>

          <ul>
            <li>{t("policy.terms.section5.items.payment")}</li>
            <li>{t("policy.terms.section5.items.plan")}</li>
            <li>{t("policy.terms.section5.items.auto_renew")}</li>
            <li>{t("policy.terms.section5.items.cancel")}</li>
          </ul>

          <h3>{t("policy.terms.section5.subscription_refund_title")}</h3>

          <ul>
            <li>{t("policy.terms.section5.subscription_refund_items.period")}</li>

            <li>{t("policy.terms.section5.subscription_refund_items.expired")}</li>
            <li>{t("policy.terms.section5.subscription_refund_items.no_partial")}</li>
            <li>{t("policy.terms.section5.subscription_refund_items.renewal")}</li>
            <li>{t("policy.terms.section5.subscription_refund_items.request")}</li>
            <li>{t("policy.terms.section5.subscription_refund_items.processor")}</li>
          </ul>
        </>
      ) : (
        <>
          <h2>{t("policy.terms.section5.title_free")}</h2>

          <p>{t("policy.terms.section5.p1_free")}</p>

          <ul>
            <li>{t("policy.terms.section5.free_items.download")}</li>
            <li>{t("policy.terms.section5.free_items.ai")}</li>
            <li>{t("policy.terms.section5.free_items.storage")}</li>
            <li>{t("policy.terms.section5.free_items.trash")}</li>
          </ul>
        </>
      )}

      <h3>{t("policy.terms.section5.printing_refund_title")}</h3>

      <ul>
        <li>{t("policy.terms.section5.printing_refund_items.opened")}</li>
        <li>{t("policy.terms.section5.printing_refund_items.period")}</li>
        <li>{t("policy.terms.section5.printing_refund_items.defect")}</li>
        <li>{t("policy.terms.section5.printing_refund_items.change_of_mind")}</li>
      </ul>

      <h2>{t("policy.terms.section5_1.title")}</h2>

      <p>{t("policy.terms.section5_1.p1")}</p>

      <ul>
        <li>{t("policy.terms.section5_1.items.method")}</li>
        <li>{t("policy.terms.section5_1.items.estimate")}</li>
        <li>{t("policy.terms.section5_1.items.production")}</li>
        <li>{t("policy.terms.section5_1.items.quality")}</li>
      </ul>

      <h2>{t("policy.terms.section5_2.title")}</h2>

      <ul>
        <li><strong>{t("policy.terms.section5_2.items.origin")}</strong></li>
        <li>{t("policy.terms.section5_2.items.domestic", shipVars)}</li>
        <li>{t("policy.terms.section5_2.items.jeju", shipVars)}</li>
        <li>{t("policy.terms.section5_2.items.island", shipVars)}</li>
        {false && <li>{t("policy.terms.section5_2.items.international")}</li>}
        <li>{t("policy.terms.section5_2.items.delivery_time")}</li>
      </ul>

      <h2>{t("policy.terms.section6.title")}</h2>

      <p>
        {t("policy.terms.section6.p1")}
      </p>

      <h2>{t("policy.terms.section7.title")}</h2>

      <p>{t("policy.terms.section7.p1")}</p>

      <ul>
        <li>{t("policy.terms.section7.items.content")}</li>
        <li>{t("policy.terms.section7.items.damage")}</li>
        <li>{t("policy.terms.section7.items.thirdparty")}</li>
      </ul>

      <h2>{t("policy.terms.section8.title")}</h2>

      <p>
        {t("policy.terms.section8.p1")}
      </p>

      <h2>{t("policy.terms.section9.title")}</h2>

      <p>
        {t("policy.terms.section9.p1")}
      </p>

      <h2>{t("policy.terms.section10.title")}</h2>

      <p>{t("policy.terms.section10.p1")}</p>

      <p>3d@makerz.co.kr</p>
    </div>
  );
}